import { call, put, takeEvery } from 'redux-saga/effects';

import apiCommon from 'api/common';

import FETCH_SETTINGS from './types';
import { finishLoading, startLoading } from '../loading/actions';

function* fetchSettings(): any {
  try {
    yield put(startLoading(FETCH_SETTINGS.PENDING));
    const settings = yield call(apiCommon.settings.get);
    yield put({ type: FETCH_SETTINGS.SUCCESS, settings });
    yield put(finishLoading(FETCH_SETTINGS.PENDING));
  } catch (error) {
    yield put({ type: FETCH_SETTINGS.FAILURE, message: error.message });
  }
}

function* saga(): any {
  yield takeEvery(FETCH_SETTINGS.PENDING, fetchSettings);
}

export default saga;
